import { IoClose } from "react-icons/io5";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function ChatWindow({
  children,
  title,
  customClass,
  onClose,
  onAnimationEnd,
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(
    <div
      className={`fixed bottom-0 left-0 z-[1000] flex h-3/5 w-full flex-col bg-altgray-50 shadow-2xl ${customClass}`}
      onAnimationEnd={onAnimationEnd}
    >
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-5 right-5 btn btn-icon btn-icon-md btn-goast"
          aria-label="Close chat"
        >
          <div className="text-2xl">
            <IoClose />
          </div>
        </button>
      )}
      <div className="p-6 text-xl font-semibold bg-white border-b md:text-2xl border-b-altgray-200">
        {title}
      </div>
      {children}
    </div>,
    document.body,
  );
}
